import 'view/style/css/main.css';
import { connect } from "react-redux";
import Section01 from 'view/parts/main/section01.js';
import Section02 from 'view/parts/main/section02.js';
import Section03 from 'view/parts/main/section03.js';
import Section04 from 'view/parts/main/section04.js';
import Section05 from 'view/parts/main/section05.js';
import classNames from "classnames";
import { useInView, InView } from "react-intersection-observer";
import React from 'react';

function Index({ state }) {

  const [ref1, inView1] = useInView({
    threshold: 0.9,
  });
  const [ref2, inView2] = useInView({
    threshold: 0.9,
  });
  const [ref3, inView3] = useInView({
    threshold: 0.1,
  });
  const [ref4, inView4] = useInView({
    threshold: 0.1,
  });
  const [ref5, inView5] = useInView({
    threshold: 0.1,
  });

  return (
    <React.Fragment>
      <Section01
        inView1={inView1}
        ref1={ref1}
        inView3={inView3}
        ref3={ref3}
        inView4={inView4}
      />
      <Section02
        inView2={inView2}
        ref2={ref2} />
      <Section03
        inView3={inView3}
        ref3={ref3} />
      <Section04
        inView4={inView4}
        ref4={ref4}
      />
      <Section05
        inView5={inView5}
        ref5={ref5}
      />
    </React.Fragment>
  );
}

export default connect(
  // props 로 넣어줄 스토어 상태값
  (state) => ({
    layout: state.layout,
  }),
  // props 로 넣어줄 액션 생성함수
  (dispatch) => ({})
)(Index);

